module.exports = __webpack_public_path__ + "01_glasses_brown.4faeed2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/01_glasses_brown.png
// module id = TPKA
// module chunks = 0